import PVSTPRServiceDetail from "./PVSTPRServiceDetail";

export default PVSTPRServiceDetail;
